import { SliderProps, Stack } from "@mui/material";
import * as _ from "lodash";
import { isEmpty } from "lodash";
import { ReactNode, type FC } from "react";
import { useController } from "react-hook-form";
import { BodyTextM } from "../Typography";
import * as StyledCommon from "./Common.styled";
import { FormError } from "./FormError";
import * as Styled from "./Slider.styled";

export type SliderInputProps = SliderProps & {
    name: string;
    disabled?: boolean;
    label?: string;
    subLabel?: ReactNode;
    minText?: string;
    maxText?: string;
    LabelComponent?: React.ElementType;
    WrapperComponent?: React.ElementType;
    afterChange?: (value: number | number[]) => void;
};

export const SliderInput: FC<SliderInputProps> = ({
    name,
    label,
    subLabel,
    minText,
    maxText,
    LabelComponent = "label",
    WrapperComponent = Stack,
    afterChange,
    ...rest
}) => {
    const { fieldState, field } = useController({ name });
    const { error } = fieldState;

    return (
        <WrapperComponent>
            {!isEmpty(label) && (
                <LabelComponent htmlFor={`${name}-name`}>
                    <StyledCommon.InputLabel>{label}</StyledCommon.InputLabel>
                </LabelComponent>
            )}
            {!isEmpty(subLabel) && (
                <StyledCommon.InputSubLabelNoPadding>{subLabel}</StyledCommon.InputSubLabelNoPadding>
            )}

            <Styled.SliderField
                id={`${name}-name`}
                value={field.value}
                {...rest}
                onChange={(_, value) => {
                    field.onChange(value);
                    afterChange?.(value);
                }}
                onBlur={field.onBlur}
                name={field.name}
                ref={field.ref}
            />
            {(!_.isEmpty(minText) || !_.isEmpty(maxText)) && (
                <Styled.SliderMinMaxStack>
                    <BodyTextM>{minText ?? " "}</BodyTextM>
                    <BodyTextM>{maxText ?? " "}</BodyTextM>
                </Styled.SliderMinMaxStack>
            )}
            <FormError error={error} fieldName={name} />
        </WrapperComponent>
    );
};
